<template>
	<div class="pt-10 pt-sm-16 pb-10 mb-16">
		<div style="max-width: 880px" class="px-4 mx-auto">
			<div class="d-flex align-center mb-7">
				<img src="@/assets/images/logo.png" alt="" />
				<!-- <v-spacer></v-spacer>
				<a href="" class="menu">이용약관</a>
				<a href="" class="menu">개인정보처리방침</a>
				<a href="" class="menu">공지사항</a> -->
			</div>
			<div class="tella-info mb-7">
				{{ $t('footer.company') }}<br />
				{{ $t('footer.ceo') }} | {{ $t('footer.company-no-1') }}: 114-87-15235
				<br class="d-block d-sm-none" />
				{{ $t('footer.company-no-2') }}<br />
				{{ $t('footer.company-no-3') }}
				<br class="d-block d-sm-none" />
				{{ $t('footer.address') }}
				<br />
				{{ $t('footer.email') }}:
				{{ language === 'ja' ? 'tellajp@tella.co.kr' : 'tella@tella.co.kr' }} |
				{{ $t('footer.cs') }}: 070-5118-9565
				<br class="d-block d-sm-none" />
				{{ $t('footer.office-hours') }}<br />
			</div>
			<div class="d-flex align-center pb-sm-12">
				<a
					v-if="language === 'ja'"
					href="https://www.instagram.com/tellajp/"
					target="_blank"
					class="mr-2"
				>
					<img src="@/assets/images/insta-icon-circle.png" alt="" />
				</a>
				<a
					v-if="language === 'ja'"
					href="https://twitter.com/TellaJapan"
					target="_blank"
					class="mr-2"
				>
					<img
						style="width: 34px"
						src="@/assets/images/twitter-icon-circle.png"
						alt=""
					/>
				</a>
				<a
					v-if="language === 'ko'"
					href="https://www.instagram.com/tellakor/"
					target="_blank"
					class="mr-2"
				>
					<img src="@/assets/images/insta-icon-circle.png" alt="" />
				</a>
				<a
					v-if="language === 'ko'"
					href="https://www.youtube.com/channel/UCXu1Dm9ocPEnu7B_Fic5HjA"
					target="_blank"
					class="mr-2"
				>
					<img src="@/assets/images/youtube-icon-circle.png" alt="" />
				</a>
				<a
					v-if="language === 'ko'"
					href="https://m.blog.naver.com/tellakor"
					target="_blank"
					class="mr-2"
				>
					<img src="@/assets/images/naver-icon-circle.png" alt="" />
				</a>
				<a
					v-if="language === 'ko'"
					href="https://www.facebook.com/TELLAKor"
					target="_blank"
					class="mr-2"
				>
					<img src="@/assets/images/facebook-icon-circle.png" alt="" />
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.menu {
	margin: 0 10px;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.71;
	letter-spacing: -0.7px;
	text-align: center;
	color: #1a1a1a;
	text-decoration: unset;
}

.tella-info {
	font-size: 12px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.83;
	letter-spacing: -0.2px;
	color: #888;
}
</style>
